import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { EMPTY, throwError, catchError } from 'rxjs';
import { DetectIpSwitchService } from '@core/errors/services/detect-ip-switch.service';

export const detectIpSwitchInterceptor: HttpInterceptorFn = (req, next) => {
  const detectIpSwitchService = inject(DetectIpSwitchService);

  return next(req).pipe(
    catchError((errorResponse: HttpErrorResponse) => {
      if (errorResponse.status === HttpStatusCode.UnavailableForLegalReasons && detectIpSwitchService.shouldHandleIpSwitch()) {
        detectIpSwitchService.handleIpSwitch();
        return EMPTY;
      }

      return throwError(() => errorResponse);
    })
  );
};
